import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Form from "react-jsonschema-form";
// import Form from "@rjsf/core";
//import * as JSONSchema from "./JSONFiles/EditableFieldJSON.json";
//import * as UISchema from "./JSONFiles/EditableFieldUI.json";
// import * as ErrorSchema from "./ErrorSchema.json";
import IDynamicFormProps from "./IDynamicForm";
import Footer from "../Footer";
import "../../../assets/sass/components/dynamicForm.scss";

import * as CONFIG from "../../../config.json";
import * as DYNAMIC_FORM_ACTIONS from "./actionCreators";
import * as DRAFT_LIST_ACTIONS from "../DraftRegistration/actionCreators";
import * as MY_CART_ACTIONS from "../MyCart/actionCreators";

import { RootState } from "../../rootReducer";
import { removeWindowBeforeUnload, addWindowBeforeUnload } from "../../utils/utils";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const Loadable = require("react-loadable");

const Loading = (error: any) => {
    if (error) {
        return <div>Error on loading!</div>;
    } else {
        return <div>Loading...</div>;
    }
};

const AccessoryAccordionWidget = Loadable({
    loader: () => import("../../widgets/AccessoryAccordion"),
    loading: Loading,
});

const InputBox = Loadable({
    loader: () => import("../../widgets/InputBoxWidget"),
    loading: Loading,
});

const DynamicLabel = Loadable({
    loader: () => import("../../widgets/DynamicLabel"),
    loading: Loading,
});

const NavigationMenu = Loadable({
    loader: () => import("../../widgets/NavigationMenu"),
    loading: Loading,
});

const DropdownWidget = Loadable({
    loader: () => import("../../widgets/DropDownWidget"),
    loading: Loading,
});

const StructureType = Loadable({
    loader: () => import("../../widgets/StructureType"),
    loading: Loading,
});

const RadioWidget = Loadable({
    loader: () => import("../../widgets/RadioWidget"),
    loading: Loading,
});

const ContainerWidget = Loadable({
    loader: () => import("../../widgets/ContainerWidget"),
    loading: Loading,
});

const TwoWayDependentWidget = Loadable({
    loader: () => import("../../widgets/TwoWayDependentWidget/index"),
    loading: Loading,
});

const CustomAddButtonWidget = Loadable({
    loader: () => import("../../widgets/CustomAddButton"),
    loading: Loading,
});

const CustomAddButtonsWrapper = Loadable({
    loader: () => import("../../widgets/CustomAddButtonsWrapper"),
    loading: Loading,
});

const LabelWidget = Loadable({
    loader: () => import("../../widgets/LabelWidget"),
    loading: Loading,
});

const TitleWidget = Loadable({
    loader: () => import("../../widgets/TitleWidget"),
    loading: Loading,
});

const SectionTitleWidget = Loadable({
    loader: () => import("../../widgets/SectionTitleWidget"),
    loading: Loading,
});

const MultiSelectWidget = Loadable({
    loader: () => import("../../widgets/MultiSelectWidget"),
    loading: Loading,
});

const CheckBoxWidget = Loadable({
    loader: () => import("../../widgets/CheckBoxWidget"),
    loading: Loading,
});

const DatePickerWidget = Loadable({
    loader: () => import("../../widgets/DatePicker"),
    loading: Loading,
});

const UnchainedDropDown = Loadable({
    loader: () => import("../../widgets/UnchainedDropDown"),
    loading: Loading,
});

const DynamicField = Loadable({
    loader: () => import("../../widgets/dynamicFeild"),
    loading: Loading,
});

const TypeAhead = Loadable({
    loader: () => import("../../widgets/typeAhead"),
    loading: Loading,
});

const PropertyManagerTypeAhead = Loadable({
    loader: () => import("../../widgets/PropertyManagerTypeAhead"),
    loading: Loading,
});

const ReviewAndPay = Loadable({
    loader: () => import("../../widgets/reviewAndPay"),
    loading: Loading,
});

const SaveTemplate = Loadable({
    loader: () => import("../../widgets/templates"),
    loading: Loading,
});

let autoSaveInterval = null;
/**
 * @category Main Component
 * @description this component renders dynamic form for editing the draft or creating the draft .. this uses react-jsonschema-form to render the dynamic form by passing
 * the JSONSchema and UI schema as parameter
 */
class DynamicForm extends React.Component<IDynamicFormProps> {
    componentDidMount() {
        addWindowBeforeUnload();
        const {
            formID,
            isSubmittedForm,
            isAlreadyPaymentInitiated,
            forminstanceTypeId,
            activeAction,
            warrantyId,
            myCartActions: { updateActiveAction },
            dynamicFormActions: { fetchFormLayoutData, fetchSavedFormLayoutData, autoSaveFormData },
            // formLayout: { JSONSchema, UISchema, ErrorSchema },
            // draftListActions: { addClickElements },
            // isApiCallInProcess,
        } = this.props;
        if (!isSubmittedForm || isAlreadyPaymentInitiated) {
            if (typeof formID === "string") {
                // if (!isApiCallInProcess && typeof formID === "string" && !JSONSchema && !UISchema && !ErrorSchema) {
                fetchFormLayoutData({ payload: formID });
            } else {
                fetchSavedFormLayoutData({ payload: { Id: formID, formInstanceId: forminstanceTypeId } });
            }
            if (activeAction && activeAction === "edit") {
                fetchSavedFormLayoutData({ payload: { Id: warrantyId, formInstanceId: forminstanceTypeId } });
                updateActiveAction({ activeAction: "editMode", warrantyId: null });
            }
            // auto save is not supposed to happen for submitted form
            autoSaveInterval = setInterval(() => {
                autoSaveFormData();
            }, CONFIG.AUTO_SAVE_INTERVAL_SECONDS * 1000);
        }
        // addClickElements("");
    }

    componentWillUnmount() {
        const { selectAddress, removeFormLayoutData } = this.props.dynamicFormActions;
        const address = {
            street: "",
            city: "",
            zip: "",
            state: "",
            postalCode: "",
            countryCode: "USA",
        };
        selectAddress({ key: "mailAddress", payload: { ...address } });
        selectAddress({ key: "buildingAddress", payload: { ...address } });
        removeFormLayoutData({ payload: false });
        removeWindowBeforeUnload();
        this.props.dynamicFormActions.updateFormType(false);
        clearInterval(autoSaveInterval);
    }

    handleLeavePage = (e) => {
        if (this.props.redirectUrl) return;
        const confirmationMessage = "You will loose information on refresh. Do you still want to leave?";
        e.returnValue = confirmationMessage;
        return window.confirm(confirmationMessage);
    };

    getWidget = (widgetName) => {
        switch (widgetName) {
            case "NavigationMenu": {
                return (props) => <NavigationMenu onChange={props.onChange} {...props} />;
            }
            case "CardList": {
                return (props) => (
                    <StructureType
                        errorSchema={this.props.formLayout.ErrorSchema}
                        onChange={props.onChange}
                        {...props}
                    />
                );
            }
            case "gaf-numericTextbox": {
                return (props) => (
                    <InputBox
                        type="number"
                        errorSchema={this.props.formLayout.ErrorSchema}
                        onChange={props.onChange}
                        {...props}
                    />
                );
            }
            case "gaf_textbox": {
                return (props) => (
                    <InputBox
                        errorSchema={this.props.formLayout.ErrorSchema}
                        type="text"
                        onChange={props.onChange}
                        {...props}
                    />
                );
            }
            case "gaf_dynamiclabel": {
                return (props) => <DynamicLabel onChange={props.onChange} {...props} />;
            }
            case "gaf_dropdown": {
                return (props) => (
                    <DropdownWidget
                        errorSchema={this.props.formLayout.ErrorSchema}
                        onChange={props.onChange}
                        {...props}
                    />
                );
            }
            case "gaf_dropdown_version_1": {
                return (props) => (
                    <UnchainedDropDown
                        errorSchema={this.props.formLayout.ErrorSchema}
                        onChange={props.onChange}
                        {...props}
                    />
                );
            }
            case "gaf_radiobtn": {
                return RadioWidget;
            }
            case "gaf_datePicker": {
                return (props) => (
                    <DatePickerWidget
                        errorSchema={this.props.formLayout.ErrorSchema}
                        minLimit={10}
                        maxLimit={0}
                        {...props}
                    />
                );
            }
            case "gaf_2wayDependentContainer": {
                return (props) => <TwoWayDependentWidget {...props} />;
            }
            case "gaf_container": {
                return (props) => <ContainerWidget errorSchema={this.props.formLayout.ErrorSchema} {...props} />;
            }
            case "gaf_custom_add_button": {
                return CustomAddButtonWidget;
            }
            case "gaf_custom_add_button_wrapper": {
                return CustomAddButtonsWrapper;
            }
            case "gaf_label": {
                return LabelWidget;
            }
            case "gaf_title": {
                return TitleWidget;
            }
            case "gaf_section_title": {
                return SectionTitleWidget;
            }
            case "gaf_multi_select": {
                return (props) => <MultiSelectWidget errorSchema={this.props.formLayout.ErrorSchema} {...props} />;
            }
            case "gaf_checkbox": {
                return CheckBoxWidget;
            }
            case "gaf_typeahead": {
                return (props) => <TypeAhead errorSchema={this.props.formLayout.ErrorSchema} {...props} />;
            }
            case "gaf_autosuggest": {
                return (props) => (
                    <PropertyManagerTypeAhead errorSchema={this.props.formLayout.ErrorSchema} {...props} />
                );
            }
            case "gaf_dynamic_field": {
                return (props) => (
                    <DynamicField
                        errorSchema={this.props.formLayout.ErrorSchema}
                        onChange={props.onChange}
                        {...props}
                    />
                );
            }
            case "gaf_summary": {
                return (props) => <ReviewAndPay onChange={props.onChange} {...props} />;
            }
            case "gaf_template": {
                return (props) => <SaveTemplate {...props} />;
            }
            case "gaf_accessory_accordion": {
                return (props) => <AccessoryAccordionWidget {...props} />;
            }
            default:
                return null;
        }
    };

    transformUISchema = (uiSchema) => {
        for (const property in uiSchema) {
            if (uiSchema.hasOwnProperty(property)) {
                if (typeof uiSchema[property] == "object") {
                    uiSchema["ui:options"] = {
                        label: false,
                    };
                    this.transformUISchema(uiSchema[property]);
                } else if (
                    (property == "ui:widget" || property == "ui:FieldTemplate") &&
                    typeof uiSchema[property] == "string"
                ) {
                    uiSchema[property] = this.getWidget(uiSchema[property]);
                    uiSchema["ui:options"] = {
                        label: false,
                    };
                }
            }
        }
        return uiSchema;
    };
    previousFormData = {};
    updatedUISchema = () => {
        const { formLayout } = this.props;
        // just for easy reference while refering local schema
        // const UISchemaCopy = JSON.parse(JSON.stringify(UISchema));
        // return this.transformUISchema(UISchemaCopy);
        return this.transformUISchema(formLayout.UISchema);
    };

    transformErrors = (errors) => {
        // to override the default errors .. but the required error is not able to over ride . if we want to use the prop name in the rror message we need to do some customization like removing the .from error.property and splitng it with capital case ..
        return errors.map((error) => {
            if (error.name === "minLength") {
                error.message = "check for the minlength";
                window["AppInsightTrace"].trackTrace(`error for the${error.name}`);
            }
            if (error.name === "integer5") {
                error.message = "should be of 5 digit number";
                window["AppInsightTrace"].trackTrace(`error for the ${error.name}`);
            }
            return error;
        });
    };

    ErrorListTemplate = ({ errors }) => {
        return (
            <ul>
                {errors.map((error) => (
                    <li key={error.stack}>add custom error message</li>
                ))}
            </ul>
        );
    };

    handleSubmit = ({ formData }) => {};

    onFormChange = ({ formData }) => {
        if (JSON.stringify(this.previousFormData) !== JSON.stringify(formData)) {
            this.previousFormData = JSON.parse(JSON.stringify(formData));
            const { modifyFormData } = this.props.dynamicFormActions;
            modifyFormData({ payload: formData });
        }
    };

    render() {
        const { formLayout, isDraft, contractorSettings } = this.props;
        const isSchemaExist = formLayout && Object.keys(formLayout).length > 0 && formLayout.JSONSchema && contractorSettings && Object.keys(contractorSettings).length > 0;
        const isDataAvailable =
            formLayout && formLayout.WarrantyData && Object.keys(formLayout.WarrantyData).length > 0;
        const showForm = isSchemaExist && (!isDraft || (isDraft && isDataAvailable));

        return showForm ? (
            <>
                <Form
                    //liveValidate
                    noHtml5Validate
                    // just for easy reference while refering local schema
                    // schema={JSONSchema}
                    schema={formLayout.JSONSchema}
                    liveOmit={true}
                    omitExtraData={true}
                    uiSchema={this.updatedUISchema()}
                    formData={formLayout.WarrantyData}
                    onChange={this.onFormChange}
                    showErrorList={false}
                    onSubmit={this.handleSubmit}
                    ErrorList={this.ErrorListTemplate}
                    transformErrors={this.transformErrors}
                    noValidate={true}
                />
                <Footer />
            </>
        ) : (
            <div className="fetchingData">Fetching Data, Please Wait...</div>
        );
    }
}

function mapStateToProps(state: RootState) {
    return {
        formLayout: state.dynamicFormInfo.layoutResponse,
        isDraft: state.dynamicFormInfo.isDraft,
        redirectUrl: state.payments.redirectUrl,
        isSubmittedForm: state.adminData.isSubmittedForm,
        isAlreadyPaymentInitiated: state.payments.isAlreadyPaymentInitiated,
        isLayoutCallInProcess: state.dynamicFormInfo.isLayoutCallInProcess,
        contractorSettings: state.dynamicFormInfo.contractorSettings || {},
        activeAction: state.myCartInfo.activeAction || null,
        warrantyId: state.myCartInfo.warrantyId || null,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(DYNAMIC_FORM_ACTIONS, dispatch),
        draftListActions: bindActionCreators(DRAFT_LIST_ACTIONS, dispatch),
        myCartActions: bindActionCreators(MY_CART_ACTIONS, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DynamicForm);
